import { request } from '../utils/request'
import { stringify } from '../utils/index'

export default {
  getappraisaltransferboxs: option => request('v1/appraisaltransferbox/getappraisaltransferboxs', option), // 查询流转箱列表
  createappraisaltransferbox: (option) => request('v1/appraisaltransferbox/createappraisaltransferbox' + stringify(option), option), // 生产流转箱
  downloadappraisaltransferboxqrs: (option) => request('v1/appraisaltransferbox/downloadappraisaltransferboxqrs' + stringify(option), option, true, false, true), // 下载流转箱

  getwarehouses: option => request('v1/wms/warehouse/getwarehouses', option), // 查询仓库列表
  addwarehouse: (option) => request('v1/wms/warehouse/addwarehouse', option), // 新增仓库
  updatewarehouse: option => request('v1/wms/warehouse/updatewarehouse', option), // 修改i仓库
  deletewarehouse: (option) => request('v1/wms/warehouse/deletewarehouse' + stringify(option), option), // 删除仓库

  getbinsets: option => request('v1/wms/warehouse/getbinsets', option), // 查询库位列表
  addbinset: (option) => request('v1/wms/warehouse/addbinset', option), // 新增库位
  updatebinset: option => request('v1/wms/warehouse/updatebinset', option), // 修改库位
  deletebinset: (option) => request('v1/wms/warehouse/deletebinset' + stringify(option), option), // 删除库位
  getbinnoqrcode: (option) => request('v1/wms/warehouse/getbinnoqrcode' + stringify(option), option, true, false, true), // 下载库位码
  getappraisalorders: option => request('v1/appraisalorder/wms/getappraisalorders', option), // 查询库位列表
  reportingloss: (option) => request('v1/appraisalorder/wms/reportingloss' + stringify(option), option), // 库位库存报损

  getstaffs: option => request('v1/sysstaff/getstaffs', option), // 查询仓管账号
  addstaff: option => request('v1/sysstaff/addstaff', option), // 新增仓管账号
  updatestaff: option => request('v1/sysstaff/updatestaff', option), // 修改仓管账号
  deletestaff: option => request('v1/sysstaff/deletestaff' + stringify(option), option), //  删除仓管账号

  getappraisalordertimeoutnotifys: option => request('v1/appraisalordertimeoutnotify/getappraisalordertimeoutnotifys', option), // 查询超期预警列表
  clearnotification: option => request('v1/appraisalordertimeoutnotify/clearnotification' + stringify(option), option), //  按id清空超期预警
  clearnotifications: option => request('v1/appraisalordertimeoutnotify/clearnotifications' + stringify(option), option) //  批量清空超期预警
}
